import { themeAtom } from "../../shared/atoms";
import RatingRow from "../../voyage-assessment/components/RatingRow";
import FinalGrade from "./FinalGrade";
import { useAtomValue } from "jotai";
import { twMerge } from "tailwind-merge";

type Props = { title: string; number: number | "-"; onClick?: () => void; readonly: boolean };

const QualityRating = ({ title, number: rating, onClick, readonly }: Props) => {
  const theme = useAtomValue(themeAtom);

  return (
    <div data-test="quality-rating">
      <p className={twMerge("mb-1 text-[14px]", theme.vesselDetails.infoText)}>{title}</p>
      <div className="flex gap-2">
        <FinalGrade rating={rating} />
        <RatingRow
          onClick={onClick}
          showStarCount={false}
          isVertical
          starFillColor={theme.vesselDetails.starFill}
          rating={rating === "-" ? 0 : rating}
          readonly={readonly}
        />
      </div>
    </div>
  );
};

export default QualityRating;
